import CancelOrder from "../cancel-order/CancelOrder";
import GeneralDeliveryQueries from "../general-delivery-queries/GeneralDeliveryQueries";
import HelpWithDeliveryProblemOther from "../help-with-delivery-problem-other/HelpWithDeliveryProblemOther";
import MakingChangesToMyDelivery from "../making-changes-to-my-delivery/MakingChangesToMyDelivery";
import TrackMyOrder from "../track-my-order/TrackMyOrder";

const getSolutionComponent = id => {
  switch (id) {
    case "cancelOrder":
      return CancelOrder;
    case "generalDeliveryQueries":
      return GeneralDeliveryQueries;
    case "helpWithDeliveryProblemOther":
      return HelpWithDeliveryProblemOther;
    case "makingChangesToMyDelivery":
      return MakingChangesToMyDelivery;
    case "trackMyOrder":
      return TrackMyOrder;
    default:
      return null;
  }
};

export default getSolutionComponent;
